<template>
  <div>
    <div v-if="show">
      <div class="titles">
        <div class="title titleLeft">
          主开通人
          <span v-if="reviseInfo && oldData">{{
            hostData[0].state == "Pass"
              ? "审核通过"
              : hostData[0].state == "ChangeAgain"
              ? "修改审核被驳回"
              : hostData[0].state == "Change"
              ? "修改审核中"
              : hostData[0].state == "Wait"
              ? "待审核"
              : hostData[0].state == "Fail"
              ? "审核驳回"
              : ""
          }}</span>
          <span style="color: #333"
            >(主开通人是企业展后接收数据的唯一邮箱)</span
          >
        </div>
        <div
          class="titleRight pointer"
          v-if="hostData.length > 0"
          @click="detailPeople"
        >
          修改
        </div>
      </div>
      <div>
        <Row :gutter="30">
          <Col
            :md="12"
            :xl="8"
            :xxl="6"
            class="w-20"
            v-if="hostData.length < 1"
          >
            <div class="addPro pro pointer" @click="hostPeople">
              <i class="icon iconfont icon-jia3"></i>
              <span>添加联系人</span>
            </div>
          </Col>
          <Col
            :md="12"
            :xl="8"
            :xxl="6"
            v-if="hostData.length > 0"
            class="w-20"
          >
            <div class="pro proText">
              <p>姓名：{{ hostData[0].name }}</p>
              <p>证件号：{{ hostData[0].idNumber }}</p>
              <p>手机：{{ hostData[0].phoneNumber }}</p>
              <p>邮箱：{{ hostData[0].email }}</p>
            </div>
          </Col>
        </Row>
      </div>
      <div class="titles">
        <div class="titleNo titleLeft">
          次开通人
          <span style="color: #333"
            >(次开通人是企业指定的数据收集者，不具备数据接收功能)</span
          >
        </div>
        <div class="titleRight pointer" @click="secondPeople">添加联系人</div>
      </div>
      <div class="p30">
        <el-table
          :data="secondData"
          empty-text="没有信息"
          border
          style="width: 100%"
        >
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="phoneNumber" label="手机号"> </el-table-column>
          <el-table-column prop="idType" label="证件类型">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.idType == "IDC01"
                    ? "中国大陆居民身份证"
                    : scope.row.idType == "IDC02"
                    ? "护照"
                    : scope.row.idType == "IDC03"
                    ? "港澳台居民居住证"
                    : scope.row.idType == "IDC04"
                    ? "台胞证"
                    : scope.row.idType
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="idNumber" label="证件号"> </el-table-column>
          <el-table-column prop="email" label="邮箱"> </el-table-column>
          <el-table-column prop="department" label="部门"> </el-table-column>
          <el-table-column prop="jobTitle" label="职务"> </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                @click="delClick(scope.row, scope.$index)"
                type="text"
                size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="titles">
        <div class="titleNo titleLeft">订单信息</div>
      </div>
      <div class="numbers">
        <div>开通订单数 (999条/单)</div>
        <div>
          <input
            type="number"
            v-model="lengths"
            v-if="reviseInfo && !reviseInfoZbr"
            disabled
            style="width: 80px"
          />
          <input
            type="number"
            v-model="lengths"
            v-if="!reviseInfo || reviseInfoZbr"
            disabled
            style="width: 80px"
          />
          <span
            >每人默认对应一条订单，如需增加订单条数请联系工作人员:010-84556507</span
          >
        </div>
        <Button
          style="width: 120px"
          type="primary"
          :loading="loading"
          @click="successSubmit()"
          >确定提交</Button
        >
      </div>
    </div>

    <div v-if="!show" class="successPage">
      <div>提交成功!主办方将在收集截至后3个工作日内开通，请耐心等待。</div>
      <div>
        <i class="el-icon-success"></i>
      </div>

      <Button style="width: 160px" type="primary" @click="show = true"
        >返回修改信息</Button
      >
    </div>

    <iModal
      :title="title"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="700px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            :show-message="showMessage"
            @submit.native.prevent
            :label-width="160"
          >
            <FormItem label="联系人" prop="contactId">
              <Select
                v-model="formInline.contactId"
                style="width: 400px"
                @on-change="onchange"
              >
                <Option
                  v-for="item in typeList"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>

            <div class="addPeople pointer" @click="addMan">添加新联系人</div>

            <FormItem label="手机号">
              <Input
                style="width: 400px"
                type="tel"
                placeholder="请输入手机号"
                disabled
                v-model="formInline.phoneNumber"
              />
              <span
                v-if="formInline.phoneNumber"
                class="pointer"
                @click="editFrom"
                >修改</span
              >
            </FormItem>

            <FormItem label="证件类别" prop="idType">
              <Select
                v-model="formInline.idType"
                style="width: 400px"
                @on-change="changeCardType"
              >
                <Option label="中国大陆居民身份证" value="中国大陆居民身份证" />
                <Option label="护照" value="护照" />
                <Option label="港澳台居民居住证" value="港澳台居民居住证" />
                <Option label="台胞证" value="台胞证" />
              </Select>
            </FormItem>

            <FormItem label="证件号" prop="idNumber">
              <Input
                style="width: 400px"
                type="text"
                placeholder="请输入证件号"
                v-model="formInline.idNumber"
              />
            </FormItem>

            <FormItem label="邮箱">
              <Input
                style="width: 400px"
                type="email"
                disabled
                placeholder="请输入你的邮箱"
                v-model="formInline.email"
              />
            </FormItem>

            <FormItem label="部门" prop="department">
              <Input
                style="width: 400px"
                type="text"
                placeholder="请输入你的部门"
                v-model="formInline.department"
              />
            </FormItem>

            <FormItem
              label="国家/地区"
              v-if="CountryList.length"
              prop="country"
            >
              <Select
                v-model="formInline.country"
                filterable
                clearable
                style="width: 400px"
                @on-change="countryChange"
              >
                <Option
                  v-for="item in CountryList"
                  :value="item.label"
                  :key="item.id"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>

            <FormItem
              v-show="
                formInline.country == '中国/zhongguo' ||
                formInline.country == '中国/China'
              "
              prop="province"
            >
              <template #label> <span>*</span>省份/地区 </template>
              <Select
                v-model="formInline.province"
                filterable
                clearable
                style="width: 400px"
                @on-change="provinceChange"
              >
                <Option
                  v-for="item in ProvinceList"
                  :value="item.label"
                  :key="item.id"
                  >{{ item.label }}</Option
                >
              </Select>
            </FormItem>
            <FormItem label="职务">
              <Input
                style="width: 400px"
                type="text"
                disabled
                placeholder="请输入你的部门"
                v-model="formInline.jobTitle"
              />
            </FormItem>
            <div
              class="zlchange"
              v-if="hostData1.length < 1 && typePeople == 1 && !reviseInfo"
            >
              <div class="zlchangeTitle">开通说明</div>
              <div class="zlchangeUrl">
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  type="drag"
                  action="https://api.cmef.com.cn/api/upload/files"
                  multiple
                  style="display: inline-block; width: 100px"
                >
                  <Button style="width: 100px" type="primary">上传</Button>
                </Upload>
                <div
                  style="
                    width: 400px;
                    line-height: 40px;
                    color: blue;
                    position: relative;
                    padding-right: 20px;
                  "
                  class="ellipsis pointer"
                  v-if="fileUrl"
                  @click="checkLink(1)"
                >
                  {{ fileUrl }}
                  <div class="iconDel" @click.stop="delUrl">
                    <i class="el-icon-circle-close"></i>
                  </div>
                </div>
                <div class="textPhoto" style="margin-top: 10px">
                  添加主开通人需要提供主开通人开通说明
                </div>
                <div class="textPhoto">
                  说明参考:<span class="pointer" @click="checkLink(3)"
                    >点击此处查看</span
                  >
                </div>
              </div>
            </div>
            <div
              class="zlchange"
              v-if="hostData1.length > 0 && typePeople == 1 && reviseInfo"
            >
              <div class="zlchangeTitle">资料变更说明</div>
              <div class="zlchangeUrl">
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  type="drag"
                  action="https://api.cmef.com.cn/api/upload/files"
                  multiple
                  style="display: inline-block; width: 100px"
                >
                  <Button style="width: 100px" type="primary">上传</Button>
                </Upload>
                <div
                  style="
                    width: 400px;
                    line-height: 40px;
                    color: blue;
                    position: relative;
                    padding-right: 20px;
                  "
                  class="ellipsis pointer"
                  v-if="fileUrl"
                  @click="checkLink(1)"
                >
                  {{ fileUrl }}
                  <div class="iconDel" @click.stop="delUrl">
                    <i class="el-icon-circle-close"></i>
                  </div>
                </div>
                <div class="textPhoto" style="margin-top: 10px">
                  修改主开通人需要提供主开通人资料变更说明
                </div>
                <div class="textPhoto">
                  说明参考:<span class="pointer" @click="checkLink(2)"
                    >点击此处查看</span
                  >
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>

      <div slot="footer">
        <Button style="width: 90px" @click="cancel">取消</Button>
        <Button
          style="width: 90px"
          type="primary"
          @click="handleSubmit('formInline')"
          >确定</Button
        >
      </div>
    </iModal>
    <iModal
      title="温馨提示"
      v-model="oldModal"
      class-name="vertical-center-modal"
      width="700px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">是否调取历史申请信息？</div>
      </div>

      <div slot="footer">
        <Button style="width: 90px" @click="cancel">否</Button>
        <Button
          style="width: 90px"
          type="primary"
          @click="timeSubmit('formInline')"
          >是</Button
        >
      </div>
    </iModal>
    <addManModel
      :show="modelShow"
      :modelTitle="modelTitle"
      :options="options"
      :linkType="linkType"
      @close="modelShow = false"
      @addFinsh="addFinsh"
    ></addManModel>
    <scanPhoto
      :show="photoShow"
      @addPhoto="addPhoto"
      @close="photoShow = false"
    ></scanPhoto>
  </div>
</template>
  
  <script>
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
import regular from "@/other/regular";
import addManModel from "../../set/company-info/subpages/company-info-linkman/add-operate.vue";
import scanPhoto from "./exhibition-scan-photo.vue";
export default {
  name: "scanCreat",
  props: {
    infoList: Object,
  },
  components: {
    addManModel,
    scanPhoto,
  },

  data() {
    const validateProvince = (rule, value, callback) => {
      if (
        this.formInline.country == "中国/zhongguo" ||
        this.formInline.country == "中国/China"
      ) {
        if (value == "" || value == undefined) {
          callback(new Error("省份/地区不能为空"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      startTime: "",
      endTime: "",
      oldModal: false,
      uploadList: [],
      defaultList: [],
      show: true,
      photoShow: false,
      typeList: [],
      numberAll: 8,
      showModal: false,
      showModalNew: false,
      showMessage: false,
      reviseInfoZbr: false,
      fileUrl: "",
      loading: false,
      formInline: {
        contactId: "",
        name: "",
        phoneNumber: "",
        firstFileUrl: "",
        idType: "",
        idNumber: "",
        email: "",
        department: "",
        jobTitle: "",
        fileUrl: "",
        country: "",
        province: "",
      },
      ruleInline: {
        contactId: [
          { required: true, message: "联系人不能为空", trigger: "change" },
        ],
        idType: [
          { required: true, message: "证件类别不能为空", trigger: "change" },
        ],
        idNumber: [
          { required: true, message: "证件号不能为空", trigger: "change" },
        ],
        department: [
          { required: true, message: "部门不能为空", trigger: "change" },
        ],
        country: [
          { required: true, message: "国家/地区不能为空", trigger: "change" },
        ],
        province: [{ validator: validateProvince, trigger: "change" }],
      },
      formInlineNew: {},
      ruleInlineNew: {
        name: [{ required: true, message: "联系人不能为空", trigger: "blur" }],
        phoneNumber: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
        ],
        idType: [
          { required: true, message: "证件类别为空", trigger: "change" },
        ],
        idNumber: [
          { required: true, message: "证件号不能为空", trigger: "blur" },
        ],
        email: [{ required: true, message: "邮箱不能为空", trigger: "blur" }],
        department: [
          { required: true, message: "部门不能为空", trigger: "blur" },
        ],
        jobTitle: [
          { required: true, message: "职务不能为空", trigger: "blur" },
        ],
      },
      info: {
        name: "111",
        card: "111",
        phone: "111",
        email: "111",
      },
      typePeople: 1,
      tableData: [],
      hostData: [],
      hostData1: [],
      secondData: [],
      addDate: [],
      deleteDate: [],
      addHostDate: [],
      linkType: [],
      lengths: 0,
      title: "",
      ChangeMainByContactIdDto: null,
      modelShow: false,
      selectPeopleCurrent: "",
      currentName: "",
      reviseEmail: "",
      modelTitle: "编辑联系人",
      reviseInfo: false,
      oldData: false,
      options: {
        msg: "",
        model: "edit",
        status: 1,
      },
      CountryList: [],
      ProvinceList: [],
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      joinInfo: "loginModule/getJoinInfo",
      exhibition: "loginModule/getExhibition",
      uploadUrl3: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
    header() {
      return this.$store.state.header;
    },
  },
  // watch: {
  //   "formInline.country": function (newVal) {
  //     if (newVal === "中国") {
  //       this.$nextTick(() => {
  //         this.$refs.formInline.validateField("province");
  //       });
  //     }
  //   },
  // },
  created() {
    this.fromData();

    // this.peopleList()
    this.getYesLink();
    this.getLinkType();
    this.timeNow();
    this.getCountry();
  },
  methods: {
    ...mapActions({
      GetAllContact: "exhibitionScan/GetAllContact",
      SaveAll: "exhibitionScan/SaveAll",
      GetAllContactPerson: "exhibitionScan/GetAllContactPerson",
      realAuth: "realAuth",
      GetAllContactPersonByCompid: "exhibitionScan/GetAllContactPersonByCompid",
      getcontacttime: "hostSetModule/getcontacttime",
      getCountryNew: "getCountryNew",
    }),

    //获取国家列表
    async getCountry() {
      let data = await this.getCountryNew();
      console.log(data, "data");
      if (data.length) {
        let arr = [];
        data.forEach((e) => {
          e.label = e.name + "/" + e.pinyin;
        });
        this.CountryList = data;
        this.getProvince();
      }
    },
    // 国家点击事件
    async countryChange(val) {
      this.CountryList.map((e) => {
        if (val == e.label) {
          this.getProvince(e.id);
        }
      });
    },

    // 获取省份
    async getProvince(id) {
      let data = this.CountryList[0].childrens;
      console.log(data, "data");
      //    if (data.length) {

      data.forEach((e) => {
        e.label = e.name + "/" + e.pinyin;
      });

      this.ProvinceList = [];

      this.ProvinceList = data;

      // }
      console.log(this.ProvinceList, "ProvinceList");
    },
    // 省份点击事件
    async provinceChange(val) {
      console.log(this.formInline);
    },
    async timeNow() {
      let timer = await this.getcontacttime(this.exhibition.id);
      if (timer.time) {
        this.startTime = timer.time.startTime;
        this.endTime = timer.time.endTime;
      }
    },
    async fromData() {
      let req1 = {
        id: this.company.id,
        exhibitionid: this.exhibition.id,
      };
      let infos = await this.GetAllContactPersonByCompid(req1);
      if (infos[0].exhibitionId == this.exhibition.id) {
        this.assignment(1);
        this.oldData = true;
      } else {
        this.oldModal = true;
      }
    },
    timeSubmit() {
      this.assignment(2);
      this.oldModal = false;
      this.oldData = false;
    },
    async assignment(index) {
      let req1 = {
        id: this.company.id,
        exhibitionid: this.exhibition.id,
      };
      let info = await this.GetAllContactPersonByCompid(req1);
      this.tableData = info;
      let hostDataNew = [];
      let secondData1 = [];
      info.forEach((element) => {
        if (element.isMain) {
          hostDataNew.push(element);
          this.fileUrl = element.fileUrl;
          this.formInline = element;
          this.reviseEmail = element.email;
        } else {
          secondData1.push(element);
        }
      });
      if (info.length > 0) {
        this.reviseInfo = true;
        this.lengths = info.length;
      }
      this.hostData1 = hostDataNew;
      this.hostData1[0].idType =
        this.hostData1[0].idType == "IDC01"
          ? "中国大陆居民身份证"
          : this.hostData1[0].idType == "IDC02"
          ? "护照"
          : this.hostData1[0].idType == "IDC03"
          ? "港澳台居民居住证"
          : this.hostData1[0].idType == "IDC04"
          ? "台胞证"
          : this.hostData1[0].idType;
      this.hostData = hostDataNew;
      this.hostData[0].idType =
        this.hostData1[0].idType == "IDC01"
          ? "中国大陆居民身份证"
          : this.hostData1[0].idType == "IDC02"
          ? "护照"
          : this.hostData1[0].idType == "IDC03"
          ? "港澳台居民居住证"
          : this.hostData1[0].idType == "IDC04"
          ? "台胞证"
          : this.hostData1[0].idType;
      this.secondData = secondData1;
    },
    async peopleList() {
      let req = {
        id: this.company.id,
      };
      let res = await this.GetAllContact(req);
      this.typeList = res;
    },
    async handleSubmit(name) {
      this.showMessage = true;
      let valid = await this.validForm(name);
      if (!valid) return;
      // this.loading = true;
      this.formInline.idNumber = this.formInline.idNumber.replace(
        /^\s+|\s+$/g,
        ""
      );
      if (this.formInline.idType == "中国大陆居民身份证") {
        if (!regular.idCardValid(this.formInline.idNumber)) {
          this.$Message.warning("证件号码格式不正确");
          return;
        }
      }
      if (this.formInline.idType == "护照") {
        if (!regular.isPassPortCard(this.formInline.idNumber)) {
          this.$Message.warning("证件号码格式不正确");
          return;
        }
      }
      if (this.formInline.idType == "台胞证") {
        if (!regular.isTWCard(this.formInline.idNumber)) {
          this.$Message.warning("证件号码格式不正确");
          return;
        }
      }
      if (this.formInline.idType == "港澳台居民居住证") {
        if (!regular.isHKCard(this.formInline.idNumber)) {
          this.$Message.warning("证件号码格式不正确");
          return;
        }
      }

      if (this.formInline.idType == "中国大陆居民身份证") {
        let info = await this.realAuth({
          idcard: this.formInline.idNumber,
          name: this.formInline.name,
        });
        if (!info || !info.successed) {
          let msgText =
            info.msg == "(姓名)不符合规则" ? "姓名与身份证号不匹配" : info.msg;
          this.$Message.warning(msgText, 50);
          return;
        }
      }
      if (
        this.reviseInfo &&
        this.title == "修改主联系人" &&
        this.fileUrl == ""
      ) {
        this.$Message.warning("请上传资料变更说明");
        return;
      }
      if (
        !this.reviseInfo &&
        (this.title == "添加主联系人" || this.title == "修改主联系人") &&
        this.fileUrl == ""
      ) {
        this.$Message.warning("请上传开通说明");
        return;
      }
      if (this.reviseInfo && this.title == "修改主联系人" && this.fileUrl) {
        this.reviseInfoZbr = true;
      }

      if (this.reviseInfo && this.title == "修改主联系人") {
        this.formInline.fileUrl = this.fileUrl;
      }
      if (
        !this.reviseInfo &&
        (this.title == "添加主联系人" || this.title == "修改主联系人")
      ) {
        this.formInline.firstFileUrl = this.fileUrl;
      }
      if (this.typePeople == 1) {
        this.hostData = [];
        this.addHostDate = [];
        this.hostData.push(this.formInline);
        this.addHostDate.push(this.formInline);
      } else {
        this.secondData.push(this.formInline);
        this.addDate.push(this.formInline);
      }
      this.lengths = this.hostData.length + this.secondData.length;

      this.showModal = false;
      this.showModalNew = false;
    },
    // 选择联系人
    onchange(res) {
      let info = {};
      // this.formInline = {
      //     contactId: '',
      //     name: '',
      //     phoneNumber: '',
      //     firstFileUrl: '',
      //     idType: '',
      //     idNumber: '',
      //     email: '',
      //     department: '',
      //     jobTitle: '',
      //     fileUrl: ''
      //   }
      this.typeList.forEach((element) => {
        if (element.id == res) {
          this.selectPeopleCurrent = element;
          (this.formInline.compId = this.company.id),
            (this.formInline.contactId = element.id);
          (this.formInline.name = element.name),
            (this.formInline.phoneNumber = element.mob),
            (this.formInline.idType = ""),
            (this.formInline.idNumber = ""),
            (this.formInline.email = element.email),
            (this.formInline.department = ""),
            (this.formInline.jobTitle = element.jobTitle),
            (this.formInline.isMain = this.typePeople == 1 ? true : false);
          this.currentName = element.name;
          (this.formInline.fileUrl = ""), (this.fileUrl = "");
          this.formInline.type = "CN";
        }
      });
      if (this.reviseInfo && this.title == "修改主联系人") {
        this.formInline.fileUrl = "";
      }
      if (
        !this.reviseInfo &&
        (this.title == "添加主联系人" || this.title == "修改主联系人")
      ) {
        this.formInline.firstFileUrl = "";
      }
      this.tableData = [];
    },
    detailPeople() {
      let timer = this.timerShow();
      if (!timer) {
        return;
      }
      this.showModal = true;
      this.showModalNew = false;
      this.title = "修改主联系人";
      this.typePeople = 1;
      this.formInline = {};
      console.log(this.hostData);
      this.formInline = JSON.parse(JSON.stringify(this.hostData))[0];
      if (this.reviseInfo && this.title == "修改主联系人") {
        this.fileUrl = this.formInline.fileUrl;
      }
      if (
        !this.reviseInfo &&
        (this.title == "添加主联系人" || this.title == "修改主联系人")
      ) {
        this.fileUrl = this.formInline.firstFileUrl;
      }
      let array = ["中国大陆居民身份证", "护照", "港澳台居民居住证", "台胞证"];
      if (array.indexOf(this.formInline.idType) < 1) {
        this.formInline.idType =
          this.formInline.idType == "Mainland China Resident ID Card"
            ? "中国大陆居民身份证"
            : this.formInline.idType == "passport"
            ? "护照"
            : this.formInline.idType ==
              "Residence Permit for Hong Kong, Macao and Taiwan Residents"
            ? "港澳台居民居住证"
            : "台胞证";
      }

      console.log(this.formInline);
    },
    // 主开通人编辑
    editFrom() {
      this.modelShow = true;
      this.modelTitle = "编辑联系人";
      this.typeList.forEach((element) => {
        if (element.id == this.formInline.contactId) {
          this.selectPeopleCurrent = element;
        }
      });
      console.log(this.selectPeopleCurrent);
      if (this.selectPeopleCurrent.status == 0) {
        this.options = {
          msg: this.selectPeopleCurrent,
          model: "edit",
        };
      } else {
        this.options = {
          msg: this.selectPeopleCurrent,
          model: "edit",
          status: 1,
        };
      }
      console.log(this.options);
    },
    //   删除
    delClick(row, index) {
      let timer = this.timerShow();
      if (!timer) {
        return;
      }
      if (row.id) {
        this.deleteDate.push(row);
      }
      this.secondData.splice(index, 1);
      console.log(this.secondData);
      this.lengths = this.hostData.length + this.secondData.length;
    },
    timerShow() {
      let startTime = new Date(this.startTime);
      let endTime = new Date(this.endTime);
      let currentTime = new Date();
      if (
        this.startTime &&
        this.endTime &&
        currentTime >= startTime &&
        currentTime <= endTime
      ) {
        return true;
      } else {
        this.$Message.warning("展讯通申请暂未开启，请耐心等待~");
        return false;
      }
    },
    // 保存提交
    async successSubmit() {
      console.log(this.exhibition);
      let timer = this.timerShow();
      if (!timer) {
        return;
      }
      this.loading = true;
      this.tableData = [...this.hostData, ...this.secondData];
      let body = {
        compId: this.company.id,
        Email: this.reviseEmail ? this.reviseEmail : this.hostData[0].email,
        List: this.tableData,
        exhibitionid: this.exhibition.id,
      };
      let res = await this.SaveAll(body);
      console.log(res);
      if (!res.successed) {
        this.loading = false;
        this.$Message.warning(res.msg);
        return;
      }
      this.fromData();
      this.show = false;
      this.loading = false;
    },
    addFinsh() {
      this.modelShow = false;
      this.getYesLink();
      this.formInline = {};
      this.formInline.name = null;
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    addPeople() {
      this.showModal = false;
      this.showModalNew = true;
    },
    hostPeople() {
      this.showMessage = false;
      this.showModal = true;
      this.showModalNew = false;
      this.title = "添加主联系人";
      this.typePeople = 1;
      this.formInline = {
        name: "",
        phoneNumber: "",
        idType: "",
        idNumber: "",
        email: "",
        department: "",
        jobTitle: "",
      };
      // this.showMessage = true
    },
    secondPeople() {
      let timer = this.timerShow();
      if (!timer) {
        return;
      }
      this.showMessage = false;
      this.showModal = true;
      this.showModalNew = false;
      this.title = "添加联系人";
      this.typePeople = 2;
      this.formInline = "";
      this.formInline = {
        contactId: null,
        name: "",
        phoneNumber: "",
        idType: null,
        idNumber: "",
        email: "",
        department: "",
        jobTitle: "",
      };
      // this.showMessage = true
      // this.$refs.formInline.resetFields(); // 清除验证结果
      console.log(this.formInline);
    },
    delUrl() {
      this.fileUrl = "";
    },
    addMan() {
      let timer = this.timerShow();
      if (!timer) {
        return;
      }
      this.modelShow = true;
      this.modelTitle = "添加联系人";
      this.options = {
        msg: null,
        model: null,
      };
    },
    addPhoto(res) {
      this.photoShow = false;
      this.fileUrl = res[0].url;
      console.log(res);
    },
    checkLink(index) {
      if (index == 1) {
        window.open(this.fileUrl, "_blank");
      } else if (index == 2) {
        window.open(
          "https://view.officeapps.live.com/op/view.aspx?src=https%3A%2F%2Fsynairsoft.obs.cn-north-4.myhuaweicloud.com%2FcloudExhibition%2Ffiles%2F202408%2F9697e50d3478429796ba6fb1c52da2d5.docx&wdOrigin=BROWSELINK",
          "_blank"
        );
      } else {
        window.open(
          "https://oss.cmef.com.cn/cloudExhibition/files/202409/3954fbfbc2f44eb2bec88ea0ba30dc9e.docx",
          "_blank"
        );
      }
    },
    cancel() {
      this.showModal = false;
      this.showModalNew = false;
      this.oldModal = false;
    },
    changeCardType() {
      this.formInlineNew.idNumber = "";
      this.formInline.idNumber = "";
    },
    uploadFile() {
      console.log(1111);
      this.photoShow = true;
      console.log(this.photoShow);
    },
    getLinkType() {
      // 获取联系人类别
      this.$http.get(`/api/LinkType/GetList`, this.header).then((res) => {
        if (res.status === 200 && res.data) {
          this.linkType = res.data;
        }
      });
    },
    // 身份证号的正则表达式  验证
    validIdNumber(rule, value, callback) {
      this.formInline.idNumber = this.formInline.idNumber.replace(
        /^\s+|\s+$/g,
        ""
      );
      if (this.formInline.idType == "IDC01") {
        if (!regular.idCardValid(this.formInline.idNumber)) {
          callback(new Error("证件号码格式不正确"));
        } else {
          callback();
        }
      }
      if (this.formInline.idType == "IDC02") {
        if (!regular.isPassPortCard(this.formInline.idNumber)) {
          callback(new Error("证件号码格式不正确"));
        } else {
          callback();
        }
      }
      if (this.formInline.idType == "IDC04") {
        if (!regular.isTWCard(this.formInline.idNumber)) {
          callback(new Error("证件号码格式不正确"));
        } else {
          callback();
        }
      }
      if (this.formInline.idType == "IDC03") {
        if (!regular.isHKCard(this.formInline.idNumber)) {
          callback(new Error("证件号码格式不正确"));
        } else {
          callback();
        }
      }
    },
    getYesLink() {
      // 获取已确认的的联系人
      this.$http
        .get(
          `/api/contact/GetByCompIdForExhibitor?compId=${this.company.id}`,
          this.header
        )
        .then((res) => {
          if (res.status === 200 && res.data) {
            this.typeList = res.data;
            this.getNoLink();
          }
        });
    },
    getNoLink() {
      // 获取未确认的的联系人
      this.$http
        .get(
          `/api/contactDown/GetRecord?joinId=${this.joinInfo.id}`,
          this.header
        )
        .then((res) => {
          if (res.status === 200 && res.data) {
            this.typeList = [...this.typeList, ...res.data];
            let araryNew = JSON.parse(JSON.stringify(this.typeList));
            let array1 = [];
            araryNew.forEach((element, index) => {
              if (element.changeState == 0 || !element.changeState) {
                array1.push(element);
              }
            });
            this.typeList = JSON.parse(JSON.stringify(array1));
          }
        });
    },

    // 上传
    handleSuccess(res, file) {
      console.log(res, 333);
      if (res && res.list.length) {
        file.url = res.list[0];
        this.fileUrl = file.url;
        console.log(this.fileUrl);
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg,png,gif格式的图片`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleBeforeUpload() {
      const limitNum = 10;
      const check = this.$refs.upload.fileList.length < limitNum;
      if (!check) {
        this.$Message.warning(`每次最多上传${limitNum}张图片`);
      }
      return check;
    },
  },
};
</script>
  
  <style lang="scss" scoped>
::deep .el-table__header-wrapper {
  background-color: #999;
}
.ivu-upload-drag {
  border: none !important;
}
.p30 {
  padding: 30px;
}
.titles {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e8eaec;
  .title:before {
    content: "*";
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 14px;
    color: #ed4014;
  }
  .titleLeft {
    padding-left: 20px;
    font-size: 14px;
    line-height: 50px;
  }
  .titleRight {
    padding-right: 20px;
    font-size: 14px;
    line-height: 50px;
    color: #ed4014;
  }
  .titleNo {
    padding-left: 30px;
  }
}

.addPro {
  margin: 30px;
  height: 200px;
  width: 300px;
  padding-top: 30px;
  background-color: #fafafa;
  .icon {
    font-size: 60px;
    text-align: center;
    display: block;
    color: #999;
  }
  span {
    display: block;
    font-size: 18px;
    color: #999;
    text-align: center;
    position: relative;
    top: -5px;
  }
}
.proText {
  padding: 30px 0 30px 30px !important;
  p {
    line-height: 30px;
  }
}
.addPeople {
  margin-left: 160px;
  color: #ed4014;
  margin-bottom: 24px;
}
span {
  color: #ed4014;
  margin-left: 10px;
}
.numbers {
  margin: 30px;
  input {
    margin: 30px 0;
  }
  span {
    color: #999;
  }
}
.pointer {
  cursor: pointer;
}
.successPage {
  text-align: center;
  padding-top: 100px;
  div {
    font-size: 16px;
    margin: 0 0 50px;
  }
  i {
    font-size: 100px;
    color: #ed4014;
  }
}
.textPhoto {
  color: #999;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.zlchange {
  display: flex;
  .zlchangeTitle {
    width: 160px;
    text-align: right;
    padding-right: 10px;
  }
  .zlchangeTitle:before {
    content: "*";
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 14px;
    color: #ed4014;
  }
}
.iconDel {
  position: absolute;
  right: 0;
  top: 0;
  color: #333;
}
</style>